import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { ContentComponent } from '@app/shared/misc/content-viewer/content-viewer.component';
import { SpinnerModule } from '@app/shared/ui/simple-components/spinner/spinner.module';

@NgModule({
  imports: [CommonModule, DropDownListModule, DatePickerModule, SpinnerModule],
  declarations: [ContentComponent],
  exports: [ContentComponent],
})
export class ContentViewerModule {}
